import request from 'superagent';

import * as types from '../constants/ActionTypes';
import { SUGGEST_URL } from '../constants/Jaws';
import { getElementOffsetById, getElementHeightById } from '../utils/dom';

function requestData() {
  return { type: types.SUGGEST_REQUEST_DATA };
}

function receiveData(data) {
  return { type: types.SUGGEST_RECEIVE_DATA, data };
}

export function incrementIndicatorIndex() {
  return (dispatch, getState) => {
    const { data, indicatorIndex } = getState().suggest;
    if (indicatorIndex >= data.length - 1) {
      dispatch({
        type: types.SUGGEST_SET_INDICATOR_INDEX,
        indicatorIndex: 0,
      });
    } else {
      dispatch({
        type: types.SUGGEST_SET_INDICATOR_INDEX,
        indicatorIndex: indicatorIndex + 1,
      });
    }
  };
}

export function decrementIndicatorIndex() {
  return (dispatch, getState) => {
    const { data, indicatorIndex } = getState().suggest;
    if (indicatorIndex === 0) {
      dispatch({
        type: types.SUGGEST_SET_INDICATOR_INDEX,
        indicatorIndex: data.length - 1,
      });
    } else {
      dispatch({
        type: types.SUGGEST_SET_INDICATOR_INDEX,
        indicatorIndex: indicatorIndex - 1,
      });
    }
  };
}

export function setIndicatorIndex(newIndex) {
  return (dispatch, getState) => {
    const { data } = getState().suggest;
    if (newIndex >= 0 && newIndex < data.length) {
      dispatch({
        type: types.SUGGEST_SET_INDICATOR_INDEX,
        indicatorIndex: newIndex,
      });
    }
  };
}

export function setSelectedIndex(newIndex) {
  return (dispatch, getState) => {
    const { data } = getState().suggest;
    if (newIndex >= 0 && newIndex < data.length) {
      dispatch({
        type: types.SUGGEST_SET_SELECTED_INDEX,
        selectedIndex: newIndex,
      });
    }
  };
}

export function closeAndReset() {
  return { type: types.SUGGEST_CLOSE_AND_RESET };
}

function setAnchor(id) {
  const padding = 10;
  const { top, left } = getElementOffsetById(id);
  const height = getElementHeightById(id);
  return {
    type: types.SUGGEST_SET_ANCHOR,
    top: top + height + padding,
    left,
    anchorId: id,
  };
}

const columns = 'ITEM, LONG_NAME, SECTOR, SHORT_NAME, TYPE';

export function fetchData(group, query, anchorId) {
  return dispatch => {
    dispatch(setAnchor(anchorId));
    dispatch(requestData());
    return request
      .get(`${SUGGEST_URL}`)
      .query({ group, query, columns })
      .end((err, res) => {
        if (err) throw new Error(err);

        dispatch(receiveData(res.body));
      });
  };
}
